import Swal from 'sweetalert2'

$(document).ready(function() {

	const offerRequestLead = {
        isLoading: false,
        init() {
            $(document).on('click', '.or_person_type', this, this.personType);
            $(document).on('click', '#offer-request-send-btn', this, this.send);
        },
		personType(event) {
			const _this = event.data;
			event.preventDefault();

			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('#or-company-wrapper').hide();
			} else {
				$(this).addClass('active');
				$('#or-company-wrapper').show();
			}
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let dealerId = 1*$(this).data('dealer-id');
			let modelId = 1*$(this).data('model-id');

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#offer-request').find('.form-control').removeClass('is-invalid');
			$('#offer-request').find('.form-check-input').removeClass('is-invalid');

			if($('.or_person_type').hasClass('active')) {
				if ($('#company').val() == '') {
					$('#company').addClass('is-invalid');
					errors = true;
				}
				if ($('#cui').val() == '') {
					$('#cui').addClass('is-invalid');
					errors = true;
				}
			}
			if ($('#model').val() == '' && 1*$(this).data('id') < 1) {
				$('#model').addClass('is-invalid');
				errors = true;
			}
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if (!$('#terms-and-conditions').is(":checked")) {
				$('#terms-and-conditions').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#or-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				document.getElementById('offer-request').scrollTop = 0;
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'person_type=' + ($('.or_person_type').hasClass('active')?1:0);
			values += '&id=' + $(this).data('id');
			values += '&company=' + $('#company').val();
			values += '&cui=' + $('#cui').val();
			values += '&model=' + $('#model').val();
			values += '&name=' + $('#name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&locality=' + $('#locality').val();
			values += '&payment_method=' + $('#payment_method option:selected').val();
			values += '&message=' + $('#message').val();
			values += '&newsletter=' + ($('#newsletter').is(':checked')?1:0);
			values += '&_token=' + $("meta[name=csrf-token]").attr('content');
			$.ajax({
	            type: "POST",
	            url: $(element).data('route'),
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						Swal.fire({
							//icon: 'success',
							title: 'Eroare!',
							html: response.message
						});
                        return false;
                    }

					if (response.status == 1) {
						$('#offer-request').find('.form-control').val('');
						$('#offer-request').find('.form-check-input').attr('checked', false);

						Swal.fire({
							//icon: 'success',
							title: 'Success!',
							html: response.message
						});

						// if (cookies_advertisement == 1) {
						// 	//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						// }

						// if (cookies_advertisement == 1 || cookies_social == 1) {
						// 	//fbq('track', 'Lead');
						// }

						return false;
					}

					Swal.fire({
						//icon: 'success',
						title: 'Eroare!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('#offer-request-send-btn').length) {
        offerRequestLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/offer-request-lead.js